export const routes = [
	{
		link: '/popular-meals',
		text: 'Popular Meals'
	},
	{
		link: '/menu',
		text: 'Menu'
	},
	{
		link: '/about-us',
		text: 'About Us'
	}
];
